import React, { useEffect, useState } from 'react';
import type { FC } from 'react';
import { useDrag } from 'react-dnd';
import { ReactComponent as DragIcon } from 'images/dragIcon.svg';
import { PlayerBoxName, PlayerBoxWrapper } from './styles/PlayerBoxStyles';

export interface BoxProps {
  name: string;
  type: string;
  isDropped: boolean;
  draggingHandler: (isDragging: boolean) => void;
}

export const PlayerBox: FC<BoxProps> = ({ name, type, isDropped, draggingHandler }) => {
  const [{ opacity, isDragging }, drag] = useDrag(
    () => ({
      type,
      item: { name },
      collect: (monitor) => ({
        opacity: monitor.isDragging() ? 0.5 : 1,
        isDragging: monitor.isDragging(),
      }),
    }),
    [name, type]
  );

  const [styles, setStyles] = useState({});

  useEffect(() => {
    draggingHandler(isDragging);
  }, [isDragging]);

  return (
    <PlayerBoxWrapper
      className={`${isDragging ? 'dragging' : ''}`}
      ref={drag}
      style={{
        ...styles,
        opacity,
      }}
      onMouseDown={() =>
        setStyles({
          border: '1.5px solid #EC691A',
          filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))',
        })
      }
      onMouseUp={() => setStyles({})}
      onDragEnd={() => setStyles({})}
    >
      <PlayerBoxName>{isDropped ? <s>{name}</s> : name}</PlayerBoxName>
      <DragIcon />
    </PlayerBoxWrapper>
  );
};
